module.exports = __webpack_public_path__ + "media/images/tailwind/filter-icon-03db2419591bdb5f7a1b5900b7b08212.png";